import * as Joi from 'joi';
import { ResourceFormData } from '../../../models';

const resourceSchema = Joi.object<ResourceFormData>({
  examLevel: Joi.object().required().messages({
    'any.required': `Please select Exam Level`,
    'object.base': `Please select Exam Level`,
  }),
  title: Joi.string().max(50).required().messages({
    'string.empty': 'Title is not allowed to be empty',
    'any.required': 'Title is required',
  }),
  description: Joi.string().max(200).required().messages({
    'string.empty': 'Description is not allowed to be empty',
    'any.required': 'Description is required',
  }),
});

export default resourceSchema;
